import request from '../utils/request';

/**
 * Get a list of system administrators.
 */
export function queryAdminUsers() {
  const url = '/admins';
  return request(url);
}

/**
 * Create a new administrator.
 *
 * @param {object}   data   Data of the user you want to add
 */
export function createAdminUser(data) {
  const url = '/admins';
  return request(url, {
    method: 'POST',
    data,
  });
}

/**
 * Update an exisiting administrator.
 *
 * @param {string} adminId Id of the user you want to update
 * @param {object} data Data of the user you want to update
 */
export function updateAdminUser(adminId, data) {
  const url = `/admins/${adminId}`;
  return request(url, {
    method: 'PUT',
    data,
  });
}

/**
 * Delete an exisiting administrator.
 *
 * @param {string} adminId Id of the user you want to delete
 * @param {object} data Data of the user you want to delete
 * @param {function} onSuccess Callback when delete user success
 */
export function deleteAdminUser(adminId, onSuccess) {
  const url = `/admins/${adminId}`;
  return request(url, {
    method: 'DELETE',
  }, onSuccess);
}



// WEBPACK FOOTER //
// ./src/services/adminAPI.js